module.exports = "<div [innerHtml]=\"termHtml\"></div>"